// DO NOT EDIT -- generated from Go package fs/shared/sharedapi

///////////
// Enums //
///////////

export enum DevToolsMode {
	None = "",
	Console = "Console",
	Network = "Network"
}


/////////////
// Structs //
/////////////

export interface ThumbnailDesc {
  Type: string;
  Url: string;
  ScreenWidth: number;
  ScreenHeight: number;
  Width: number;
  Height: number;
  StartTime: number;
  PlayToTime: number;
  Resources: {[key: string]: string} | null;
  BuildId: string;
  RawEventUrls: string[] | null;
}

// An action to take for a highlight
export interface Action {
  Label: string;
  Css: string;
  Link: string;
}
